import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorMessageService, WfErrorMessage } from 'wflow-cdk';

@Injectable()
export class ApiErrorsInterceptor implements HttpInterceptor {
  readonly errorMessageSvc = inject(ErrorMessageService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        if (WfErrorMessage.isErrorMessage(err?.error)) {
          err.error = this.errorMessageSvc.getLocalizedError(err.error);
        }

        throw err;
      }),
    );
  }
}
